module.exports = __webpack_public_path__ + "media/images/circle-check-sm-blue-3bfdce9006aead47602a4bd89aa899a3.svg";